import { Cookies } from 'quasar'
import IPGeolocationAPI from 'ip-geolocation-api-javascript-sdk'

export default ({ Vue }) => {
  const geoLocation = (countries) => {
    return new Promise((resolve, reject) => {
      const ipgeolocationApi = new IPGeolocationAPI('5b812cabb2914d9fb2132a2e7f74f5ab', false)

      ipgeolocationApi.getGeolocation((data) => {
        const country = countries.find(country => country.code === data.country_code2)
        if (country) {
          const countryId = country.id
          Cookies.set('ip_country', countryId)
          resolve(countryId)
        } else {
          reject(new Error('Country not found'))
        }
      })
    })
  }

  // Make it available globally via app.config.globalProperties
  Vue.prototype.$geoLocation = geoLocation
}
